import styles from './user-bubble.module.scss';

type Props = {
	text: string;
};

export const UserBubble = ({ text }: Props) => {
	return (
		<div className={styles.row}>
			<div className={styles.bubble}>{text}</div>
		</div>
	);
};
